var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUser = function SvgUser(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.335 13.125v-1.25c0-1.38-1.194-2.5-2.667-2.5H5.335c-1.473 0-2.667 1.12-2.667 2.5v1.25",
    stroke: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M7.999 6.875c1.472 0 2.666-1.12 2.666-2.5S9.471 1.875 8 1.875c-1.473 0-2.667 1.12-2.667 2.5s1.194 2.5 2.667 2.5Z",
    stroke: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export { SvgUser as ReactComponent };
export default "data:image/svg+xml,%3Csvg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'%3E %3Cpath d='M13.3346 13.125V11.875C13.3346 10.4943 12.1407 9.375 10.668 9.375H5.33464C3.86188 9.375 2.66797 10.4943 2.66797 11.875V13.125' stroke='inherit' stroke-linecap='round' stroke-linejoin='round'/%3E %3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M7.9987 6.875C9.47146 6.875 10.6654 5.75571 10.6654 4.375C10.6654 2.99429 9.47146 1.875 7.9987 1.875C6.52594 1.875 5.33203 2.99429 5.33203 4.375C5.33203 5.75571 6.52594 6.875 7.9987 6.875Z' stroke='inherit' stroke-linecap='round' stroke-linejoin='round'/%3E %3C/svg%3E";